<template>
	<main :class="(isMobile ? 'page menu-margin no-padding' : '')+' scroll-page-container scrolly-about'">
		<interface-menu/>
		<!--
		<interface-scrolly-intro-section
			:sections="sections"
			:scrolly="scrolly"
			@show-player="() => showPlayer = true"
			@go-back="goBack"
		/>
		-->
		<main :class="`page no-padding ${isMobile ? '' : 'menu-margin'} scroll-main-container`">
			<section class="scroll-container-window">
				<div class="scroll-container">
					<section class="about-section section-cont" id="introduzione" :style="sections[0].style">
						<h1>{{sections[0].title[$i18n.locale]}}</h1>
						<div class="content">
							<div />
							<div v-html="utils.markdownToHtml(sections[0].caption[$i18n.locale])" />
						</div>
					</section>
					<section class="about-section section-cont" id="il-museo" :style="sections[1].style">
						<h1>{{sections[1].title[$i18n.locale]}}</h1>
						<div class="content">
							<div />
							<div v-html="utils.markdownToHtml(sections[1].caption[$i18n.locale])" />
						</div>
					</section>
					<section class="about-section section-cont" id="percorsi" :style="sections[2].style">
						<h1>{{sections[2].title[$i18n.locale]}}</h1>
						<div class="content">
							<div>
								<router-link :to="{ name: 'scrolly atrio' }">
									<base-icon name="arrow-right 1" class="inline" />
									{{$t('il_multi_esplora_atrio')}}
								</router-link>
							</div>
							<div v-html="utils.markdownToHtml(sections[2].caption[$i18n.locale])" />
						</div>
					</section>
					<section class="about-section section-cont" id="collezione" :style="sections[3].style">
						<h1>{{sections[3].title[$i18n.locale]}}</h1>
						<div class="content">
							<div>
								<router-link :to="{ name: 'archive' }">
									<base-icon name="arrow-right 1" class="inline" />
									{{$t('home_collezione_esplora')}}
								</router-link>
							</div>
							<div v-html="utils.markdownToHtml(sections[3].caption[$i18n.locale])" />
						</div>
					</section>
					<section class="about-section section-cont" id="partecipanti" :style="sections[4].style">
						<h1>{{sections[4].title[$i18n.locale]}}</h1>
						<div class="content">
							<div />
							<div
								v-html="utils.markdownToHtml(sections[4].caption[$i18n.locale])"
								style="align-self: stretch"
								class="p-margin"
								@scroll.capture.stop
							/>
						</div>
					</section>
				</div>
			</section>
		</main>
		<scroll-events
			v-if="!isMobile"
			:inhibit="inhibitScroll"
			scroll-container-selector="scroll-container"
			@scroll-event="scrollEventHandler"
		/>
	</main>
</template>

<script type="text/javascript">
import utils from '@js/utils.js';
import InterfaceMenu from '@components/InterfaceMenu.vue';
import ScrollEvents from '@components/ScrollEvents.vue';
import cloneDeep from 'lodash.clonedeep';
import { mapGetters } from 'vuex';
import InhibitScrollContainer from '@components/InhibitScrollContainer.vue';

import scrollytime from '@js/mixins/scrollytime.js';
import scrollies from '@static/scrollies.js';

export default {
	name: 'ViewMainScrolly',
	components: {
		InterfaceMenu,
		ScrollEvents,
	},
	mixins: [
		scrollytime
	],
	computed: {
		...mapGetters(['isMobile']),
		sections() {
			return this.scrolly.sections !== undefined ? this.scrolly.sections : []
		},
	},
	data() {
		return {
			utils,
			scrolly: cloneDeep(scrollies.scrollies.find(s => s.nameCode == 'il-multi')),
		}
	},
	watch: {
		currSection(n) {
			if (this.scrollContainer !== null) {
				let temp = utils.URLToParams()
				let finalObj = {}
				if (temp) {
					delete temp.sectionId;
					delete temp.inDepth;
				}

				finalObj = cloneDeep(temp)

				if(this.currSection) {
					finalObj = {...finalObj, sectionId: this.currSection.id}
				}

				this.$router.replace({ query: finalObj })
			}
		},
	},
	methods: {
		async inhibitScrollPartecipantiList() {
			await utils.isElLoaded('#partecipanti')
			console.log('after freeze')
			document.querySelector('#partecipanti .p-margin').onwheel = e => {
				console.log('wheel')
				e.stopPropagation()
			}
		}
	},
	mounted() {
		this.initSections();

		// manage section
		let params = utils.URLToParams()
		if(!params) return

		if(params.sectionId) {
			const elem = document.getElementById(params.sectionId);
			if (elem) elem.scrollIntoView();
			// let index = this.sections.findIndex(el => el.id == params.sectionId) + 1
			// if(index > 1) this.goToSection(index)
		}

		this.inhibitScrollPartecipantiList();
	},
}
</script>

<style lang="scss" src="@css/views/ViewScrolly.scss">
</style>

<style lang="scss">
@import '@css/variables.scss';

.scrolly-about .page {
	width: var(--scrolly-w);
	height: 100vh;

	.section-cont {
		display: flex;
		flex-direction: column;
		padding: 7rem 10rem 4rem;
		position: relative;
		gap: 4rem;

		@media (max-width: $breakpoint-sm) {
			padding: 4rem 1.25rem;
			gap: 3rem;
			height: auto;
		}

		h1 {
			font-size: 4rem;
			max-width: 50rem;

			@media (max-width: $breakpoint-sm) {
				font-size: 3rem;
				max-width: min(50rem, 100vw);
			}
		}

		.content {
			display: flex;
			gap: 4rem;
			min-height: 0;

			> * {
				flex: 1 0 0;
			}

			a {
				font-size: calc(1.375 * var(--base-font-size));
				line-height: 160%;
			}

			> :last-child {
				flex: 0 0 40rem;

				overflow-y: auto;
				align-self: center;

				font-size: calc(1.25 * var(--base-font-size)); /*20px*/
				line-height: 160%;

				@media (max-width: $breakpoint-sm) {
					flex: 1 !important;
				}
			}

			h4 {
				font-weight: 500;
			}

			* + h4,
			h4:first-child {
				margin: 2rem 0;
			}

			.p-margin p {
				margin-bottom: 0.8em;
			}

			@media (max-width: $breakpoint-ml) {
				flex-direction: column;
				gap: 1.5rem;

				> * {
					flex-grow: 0;
					align-self: stretch;
				}
			}
		}
	}
}
</style>
